import React from "react";
import PropTypes from "prop-types";
import BaseScreen from "./BaseScreen";

import { NavigationService } from "../../../navigation";

// import CommonLoginModal from "../components/ui/CommonLoginModal";
import NavigateActionTypes from "../../navigation/NavigateActionTypes";
import UIDs from "../../../UIDs";

class AuthorizedScreen extends BaseScreen {

    constructor(props) {
        super(props);
    }

    componentDidUpdate(prevProps) {
        super.componentDidUpdate(prevProps);

        if (prevProps.userId != this.props.userId)
            this._redirectIfUserUnauthorized();
    }

    componentDidMount() {
        super.componentDidMount();

        this._redirectIfUserUnauthorized();
    }

    _redirectIfUserUnauthorized() {
        if (!this.isLoggedIn(this.props.userId)) {
            setTimeout(() => {
                //if not guest, user is logged out case, we redirect to login
                const fromPage = this.isLogoutScreen ? null : window.location.href;
                NavigationService.navigateToPageByUID(this, UIDs.screens.account.userlogin, {fromPage: fromPage});
            }, 0);
        }
    }
}

AuthorizedScreen.propTypes = {
    ...BaseScreen.propTypes,
    guestModalCancelCallback: PropTypes.func,
};
//default we go back to previous screen
AuthorizedScreen.defaultProps = {
    guestModalCancelCallback: () => NavigationService.navigateByAction(this, NavigateActionTypes.BACK)
};
export default AuthorizedScreen;
